import { Box, Spinner } from '@zillow/constellation-10';
import type { SpinnerPropsInterface } from '@zillow/constellation-10';

type SpinnerContainerProps = {
  size?: SpinnerPropsInterface['size'];
  height?: string;
  padding?: string | number;
};

const SpinnerContainer = ({ size = 'sm', height = '200px' }: SpinnerContainerProps) => (
  <Box
    css={{ display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '1600' }}
    style={{ height }}
    data-testid="spinnerContainer"
    aria-role="status"
  >
    <Spinner size={size} />
  </Box>
);

export { SpinnerContainer };
